export default {
  form: {
    amount: {
      label: 'Cena',
    },
    threshold: {
      label: 'Miesięczna sprzedaż',
    },
    has_pricing_tiers: {
      label: 'Cena zmienia się na podstawie miesięcznej sprzedaży',
    },
    tax_included: {
      label: 'Podatek wliczony',
    },
  },
  buttons: {
    add_tier: 'Dodaj poziom',
  },
};
